<template>
    <div class="wrapper"
        @drop.prevent="drop"
        @dragover.prevent>

        <table>
            <thead>
                <tr>
                    <th
                        v-for="key in columns"
                        :class="{ active: sortKey == key }"
                        @click="sortBy(key)">

                        {{ key | capitalize }}
                        <span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"></span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in filteredData"
                    :class="{ active: active == item }"
                    @click="active = item">

                    <td v-for="(key, index) in columns">

                        <!-- FILE -->
                        <div
                            class="file-hitbox"
                            :uid="item.id"
                            :draggable="index == 0"
                            @dragstart.stop="drag(item)"
                            @dblclick="select(item)">

                                <i v-if="index == 0" class="fa" :class="item.icon"></i>
                                <span class="text" v-text="item[key]"></span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    // import { mapActions } from 'vuex';
    import fileMixin from '../mixins.js';

    export default {
        mixins: [
            fileMixin
        ],
        props: {
            directory: Array,
            columns: Array,
            filterKey: String
        },
        data() {
            var sortOrders = {}
            this.columns.forEach(function (key) {
                sortOrders[key] = 1
            })
            return {
                active: '',
                sortKey: '',
                sortOrders: sortOrders
            }
        },

        computed: {
            filteredData() {
                var sortKey = this.sortKey
                var filterKey = this.filterKey && this.filterKey.toLowerCase()
                var order = this.sortOrders[sortKey] || 1
                var data = this.directory
                if (filterKey) {
                    data = data.filter(function (row) {
                        return Object.keys(row).some(function (key) {
                            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
                        })
                    })
                }
                if (sortKey) {
                    data = data.slice().sort(function (a, b) {
                        a = a[sortKey]
                        b = b[sortKey]
                        return (a === b ? 0 : a > b ? 1 : -1) * order
                    })
                }
                return data
            }
        },

        filters: {
            capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1)
            }
        },

        methods: {
            sortBy(key) {
                this.sortKey = key
                this.sortOrders[key] = this.sortOrders[key] * -1
            },

            alert(el) {
                console.log(el);
            }
        }
    };
</script>

<style lang="scss" scoped>

    .wrapper {
        // background: aqua;
        height: 100%;
    }

    tr .fa {
        margin-right: rem-calc(5);
    }

    tr.active td:first-child .text {
        background: #364847;
        color: #f6f6f2; // offwhite
    }

    tr.active td:first-child .fa {
        color: black; // offwhite
    }

    .text {
        padding: 0 3px;
    }

    .file-hitbox {
        display: inline-block;
    }

    table {
        position: relative; //?
        width: 100%;
        font-size: rem-calc(14);
        // table-layout: fixed;
    }

    thead tr th {
        cursor: default;
    }

    td {
        white-space: nowrap;
    }

    thead th {
        // https://stackoverflow.com/questions/21003235/creating-a-sticky-header-on-a-thead
        position: -webkit-sticky;
        position: -moz-sticky;
        position: -ms-sticky;
        position: -o-sticky;
        position: sticky;
        top: 0;
        background: #e4e5df;
        background: linear-gradient(to bottom, lighten(#e4e5df, 3%) 0%, #e4e5df 100%);
        box-shadow: 0px -1px 0px 1px rgba(black, 0.15);
    }


    .theme-os {
        thead th {
            background: rgba(black, 0.25);
            box-shadow: 0px -1px 0px 1px rgba(black, 0.5);
        }
    }

    // ----------------------------------------------------------------------

    tbody:before {
        content: "-";
        display: block;
        line-height: rem-calc(10);
        color: transparent;
    }

    th, td {
        min-width: 120px;
        padding: 1px 20px;
    }

    th {
        padding: rem-calc(4 20);
        font-size: rem-calc(13);
        background-color: rgba(#d4d5cd, 0.5);
        // color: rgba(255,255,255,0.66);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    td {

    }

    tr {
        // background-color: #f9f9f9;
        &:hover {
            // background: rgba(aqua, 0.2);
        }
    }

    th:not(:last-child) {
        resize: horizontal;
        overflow: auto;
    }

    th.active {
        // color: #fff;
        // background: #eee;
    }

    th.active .arrow {
        opacity: 1;
    }

    .arrow {
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        margin-left: 5px;
        opacity: 0.66;
    }

    .arrow.asc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid #222;
    }

    .arrow.dsc {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #222;
    }

</style>